import {Tr} from "@/i18n/i18n";
import {injectable} from "inversify";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import {PlayerActionButton} from "@/scenes.ui/player-action-button";
import PlayerStore from "@/store/player";
import {Settings} from "@/constants/settings";

@injectable()
export class GameSoundService {

    private scene!: Scene;

    public init(scene: Scene) {
        this.scene = scene;
        this.setSoundMute(PlayerStore.getSoundMute());
    }

    public doSoundMuteAdjustment(soundButton: PlayerActionButton, isSoundMute: boolean) {
        if (isSoundMute) {
            soundButton.setButtonImage(Keys.ATLAS_UI, Keys.UI_PROFILE_SOUND_ON);
            soundButton.setButtonText(Tr('vkljuchit.zvuk'));
        } else {
            soundButton.setButtonImage(Keys.ATLAS_UI, Keys.UI_PROFILE_SOUND_OFF);
            soundButton.setButtonText(Tr('vikljuchit.zvuk'));
        }
    }

    public changeSoundMute(soundButton: PlayerActionButton, musicSceneCallback: () => unknown) {
        PlayerStore.changeSoundMute().then(() => {
                if (!Settings.MUSIC_LOADED) {
                    this.setSoundMute(PlayerStore.getSoundMute());
                    musicSceneCallback();
                } else {
                    this.doSoundMuteAdjustment(soundButton, PlayerStore.getSoundMute());
                    this.setSoundMute(PlayerStore.getSoundMute());
                    this.showFeedBackOnChange(PlayerStore.getSoundMute());
                }
        });

    }

    public setSoundMute(isMute: boolean) {
        this.scene.game.sound.mute = isMute;
    }

    private showFeedBackOnChange(isSoundMute: boolean) {
        if (isSoundMute) {
            return new FeedbackPanel(this.scene, Tr('zvuk.vikljuchen'), undefined, false).show();
        }
        return new FeedbackPanel(this.scene, Tr('zvuk.vkljuchen'), undefined, true).show();
    }

}
